<div *ngIf="loading$ | async" class="spinner">
  <mat-spinner></mat-spinner>
</div>

<div class="modal" (click)="closeModal($event)" *ngIf="showFilters">
  <div class="modal-content">
    <strong>{{ "OcurrencesListFiltersTitle" | translate }}</strong>

    <div
      class="d-flex flex-column align-items-center justify-content-center mt-3"
      style="width: fit-content"
    >
      <form [formGroup]="searchFilter" class="container-form-search">
        <div class="container-input-search">
          <div class="filters-input">
            <label class="label-input-search">
              {{ "OcurrencesListFiltersSublocality" | translate }}
            </label>
            <mat-form-field
              id="select"
              style="
                width: 260px;
                background-color: #e5deff;
                border-radius: 8px;
              "
            >
              <mat-icon style="color: #5d53a7" matSuffix
                >keyboard_arrow_down</mat-icon
              >
              <mat-select
                formControlName="sublocalityComplaint"
                class="mat-select-search"
              >
                <mat-option [value]="'Todos'">
                  {{ "OcurrencesListFiltersSublocalityAll" | translate }}
                </mat-option>
                <mat-option
                  *ngFor="let sublocality of sublocalities"
                  [value]="sublocality"
                >
                  {{ sublocality }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="filters-input">
            <label class="label-input-search">
              {{ "OcurrencesListFiltersPlace" | translate }}
            </label>
            <mat-form-field
              id="select"
              style="
                width: 260px;
                background-color: #e5deff;
                border-radius: 8px;
              "
            >
              <mat-icon style="color: #5d53a7" matSuffix
                >keyboard_arrow_down</mat-icon
              >
              <mat-select
                formControlName="placeComplaint"
                class="mat-select-search"
              >
                <mat-option [value]="'Todos'">
                  {{ "OcurrencesListFiltersPlaceAll" | translate }}
                </mat-option>
                <mat-option
                  *ngFor="let place of placeComplaint"
                  [value]="place"
                >
                  {{ place }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div
            class="filters-input"
            *ngIf="searchFilter.controls['placeComplaint'].value == 'Ônibus'"
          >
            <label class="label-input-search">
              {{ "OcurrencesListFiltersBusLine" | translate }}
            </label>
            <mat-form-field
              id="select"
              style="
                width: 260px;
                background-color: #e5deff;
                border-radius: 8px;
              "
            >
              <mat-icon style="color: #5d53a7" matSuffix
                >keyboard_arrow_down</mat-icon
              >
              <mat-select formControlName="busLine" class="mat-select-search">
                <mat-option [value]="'Todos'">
                  {{ "OcurrencesListFiltersBusLineAll" | translate }}
                </mat-option>
                <mat-option *ngFor="let line of linesName" [value]="line">
                  {{ line }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="filters-input">
            <label class="label-input-search">
              {{ "OcurrencesListFiltersType" | translate }}
            </label>
            <mat-form-field
              id="select"
              style="
                width: 260px;
                background-color: #e5deff;
                border-radius: 8px;
              "
            >
              <mat-icon style="color: #5d53a7" matSuffix
                >keyboard_arrow_down</mat-icon
              >
              <mat-select
                formControlName="typeComplaint"
                class="mat-select-search"
              >
                <mat-option value="Todos">
                  {{ "OcurrencesListFiltersTypeAll" | translate }}
                </mat-option>
                <mat-option *ngFor="let type of typesComplaint" [value]="type">
                  {{ type }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <div
          style="
            margin-top: 1.5rem;
            display: flex;
            width: 100%;
            justify-content: space-between;
          "
        >
          <div class="filters-input">
            <label class="label-input-search">
              {{ "OcurrencesListFiltersGender" | translate }}
            </label>
            <mat-form-field
              id="select"
              style="
                width: 260px;
                background-color: #e5deff;
                border-radius: 8px;
              "
            >
              <mat-icon style="color: #5d53a7" matSuffix
                >keyboard_arrow_down</mat-icon
              >
              <mat-select
                formControlName="genderComplaint"
                class="mat-select-search"
              >
                <mat-option [value]="'Todos'">
                  {{ "OcurrencesListFiltersGenderAll" | translate }}
                </mat-option>
                <mat-option [value]="'WOMAN_TRANS'">
                  {{ "OcurrencesListFiltersGenderTransWoman" | translate }}
                </mat-option>
                <mat-option [value]="'WOMAN_CIS'">
                  {{ "OcurrencesListFiltersGenderCisWoman" | translate }}
                </mat-option>
                <mat-option [value]="'MAN_TRANS'">
                  {{ "OcurrencesListFiltersGenderTransMan" | translate }}
                </mat-option>
                <mat-option [value]="'MAN_CIS'">
                  {{ "OcurrencesListFiltersGenderCisMan" | translate }}
                </mat-option>
                <mat-option [value]="'NON_BINARY'">
                  {{ "OcurrencesListFiltersGenderNonBinary" | translate }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <div
          style="
            margin-top: 1.5rem;
            display: flex;
            width: 100%;
            justify-content: space-between;
            margin-bottom: 15px;
          "
        >
          <div class="filters-input">
            <label class="label-input-search">
              {{ "OcurrencesListFiltersAge" | translate }}
            </label>
            <mat-form-field
              id="select"
              style="
                width: 260px;
                background-color: #e5deff;
                border-radius: 8px;
              "
            >
              <mat-icon style="color: #5d53a7" matSuffix
                >keyboard_arrow_down</mat-icon
              >
              <mat-select formControlName="age" class="mat-select-search">
                <mat-option [value]="'Todos'">
                  {{ "OcurrencesListFiltersAgeAll" | translate }}
                </mat-option>
                <mat-option [value]="'<= 14'">
                  {{ "OcurrencesListFiltersAgeUnderOrEqual14" | translate }}
                </mat-option>
                <mat-option [value]="'15 - 18'">
                  {{ "OcurrencesListFiltersAgeFrom15To18" | translate }}
                </mat-option>
                <mat-option [value]="'19 - 29'">
                  {{ "OcurrencesListFiltersAgeFrom19To29" | translate }}
                </mat-option>
                <mat-option [value]="'30 - 39'">
                  {{ "OcurrencesListFiltersAgeFrom30To39" | translate }}
                </mat-option>
                <mat-option [value]="'40 - 49'">
                  {{ "OcurrencesListFiltersAgeFrom40To49" | translate }}
                </mat-option>
                <mat-option [value]="'50 - 59'">
                  {{ "OcurrencesListFiltersAgeFrom50To59" | translate }}
                </mat-option>
                <mat-option [value]="'>= 60'">
                  {{ "OcurrencesListFiltersAgeAboveOrEqual60" | translate }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <button
          class="btn btn-outline-secundary custom-button mt-3"
          style="font-size: 1rem"
          (click)="queryComplaints()"
        >
          {{ "OcurrencesListFiltersSubmit" | translate }}
        </button>
        <button
          class="btn btn-outline-clear custom-button clear mt-3 text-decoration-underline"
          style="font-size: 1rem"
          (click)="limparFiltros()"
        >
          {{ "OcurrencesListFiltersCleanFilters" | translate }}
        </button>
      </form>
    </div>
  </div>
</div>

<div
  [hidden]="loading$ | async"
  class=""
  style="background: #fffbff; overflow-x: hidden"
>
  <div class="row justify-content-center">
    <div
      class=""
      style="background: #fffbff; width: 100%; max-width: 100%; padding: 0"
    >
      <div
        class=""
        style="
          background: #5b43d9;
          width: 100%;
          border-bottom-left-radius: 40px;
          border-bottom-right-radius: 40px;
          margin-top: -1px;
        "
      >
        <header
          class="denounce-table-title"
          style="
            margin: 0 auto;
            max-width: 1300px;
            padding: 0;
            padding-top: 20px;
            padding-bottom: 15px;
          "
        >
          <h2 style="margin: 0 !important">
            {{ "OcurrencesListHeaderTitle" | translate }}
          </h2>
        </header>
      </div>

      <!-- Filtro -->
      <section
        class="section-filter"
        style="width: 100%; max-width: 1300px; margin: 0 auto; margin-top: 30px"
      >
        <div class="filter-container">
          <div class="flex flex-column">
            <div [formGroup]="searchForm" class="filter-bar">
              <label
                class="filter__label"
                for="search"
                style="margin-right: 30px"
              >
                <span
                  class="material-icons"
                  style="padding-bottom: 3px; cursor: pointer"
                >
                  <img src="assets/icons/search.svg" alt="" />
                </span>
                <input
                  (keyup)="filterComplaint()"
                  id="search"
                  type="search"
                  class="form-control"
                  placeholder="Pesquisar..."
                  name="search"
                  required
                  formControlName="search"
                />
              </label>
              <div
                class="input-group-append"
                style="
                  display: flex;
                  justify-content: center;
                  align-items: center;
                "
              >
                <div
                  class="select__wrapper"
                  style="
                    width: 310px;
                    cursor: pointer;
                    color: #180064 !important;
                    height: 40px;
                    border-top-left-radius: 9999px;
                    border-bottom-left-radius: 9999px;
                    background: #e5deff;
                  "
                >
                  <div
                    style="
                      height: 100%;
                      display: flex;
                      align-items: center;
                      padding-left: 15px;
                      font-family: Roboto;
                      font-size: 19px;
                      font-style: normal;
                      font-weight: 500;
                      line-height: 28px;
                      color: #180064;
                    "
                    class="input"
                    (click)="openDatePicker()"
                  >
                    {{ selectedLabel }}
                  </div>
                </div>

                <mat-form-field
                  style="
                    display: flex;
                    flex-direction: row;
                    background: #e5deff !important;
                    right: 1px !important;
                    height: 40px !important;
                    border-top-right-radius: 9999px;
                    border-bottom-right-radius: 9999px;
                    padding-right: 20px;
                  "
                >
                  <mat-datepicker-toggle
                    matSuffix
                    id="picker-toggle"
                    [for]="picker"
                    class="picker-color"
                    style="color: #180064; margin-right: 0.5rem"
                    (click)="openDatePicker()"
                  >
                    <mat-icon style="font-size: 30px" matDatepickerToggleIcon
                      >keyboard_arrow_down</mat-icon
                    >
                  </mat-datepicker-toggle>

                  <mat-datepicker-toggle
                    matSuffix
                    (click)="cleanDate()"
                    *ngIf="initialDate || endDate"
                  >
                    <mat-icon matDatepickerToggleIcon>clear</mat-icon>
                  </mat-datepicker-toggle>

                  <mat-date-range-picker #picker></mat-date-range-picker>

                  <mat-date-range-input
                    [min]="minDate"
                    [max]="maxDate"
                    [rangePicker]="picker"
                    style="display: none"
                  >
                    <input
                      matStartDate
                      [min]="minDate"
                      [max]="maxDate"
                      (dateChange)="onInitialDateChange($event)"
                    />
                    <input matEndDate (dateChange)="onEndDateChange($event)" />
                  </mat-date-range-input>
                </mat-form-field>
                <button
                  (click)="setShowFilters(true)"
                  class="btn btn-outline-primary custom-button"
                  style="margin: 0 1rem"
                >
                  <img src="assets/icons/filters.svg" alt="" />
                  {{ "OcurrencesListFiltersTitle" | translate }}
                </button>

                <button
                  class="btn btn-outline-fortiary custom-button"
                  (click)="queryComplaints()"
                >
                  {{ "OcurrencesListTableSearch" | translate }}
                </button>
              </div>
            </div>

            <div
              *ngIf="selectedFilters.length > 0 || true"
              class="flex row items-center gap-2 flex-wrap"
              [style.padding]="selectedFilters.length > 0 ? '1rem' : '0'"
            >
              <div
                class="selected-filter"
                *ngFor="let filter of selectedFilters"
              >
                {{ filter.name }}
                <mat-icon
                  style="transform: scale(0.8); cursor: pointer"
                  (click)="removeFilter(filter)"
                  >close</mat-icon
                >
              </div>
            </div>
          </div>
        </div>
      </section>
      <!--
      <div style="width: 100%; max-width: 1300px; margin: 0 auto;">
        <form [formGroup]="searchFilter" class="search-form">
          <div class="form-row search-row">
            <div class="form-group col-md-2">
              <label class="filters-name">Tipo</label>
              <select (change)="queryComplaints()" formControlName="" class="form-control filters-select fa-caret-down">
                <option>
                  Todos
                </option>
                <option *ngFor="let type of typesComplaint">
                  {{ type }}
                </option>
              </select>
            </div>
            <div class="form-group  col-md-2">
              <label class="filters-name">Linha de ônibus</label>
              <select (change)="queryComplaints()" class="form-control filters-select fa-caret-down">
                <option>
                  Todas
                </option>
                <option *ngFor="let line of linesName">
                  {{ line }}
                </option>
              </select>
            </div>
            <div class="form-group  col-md-2">
              <label class="filters-name">Lugar de ocorrência</label>
              <select (change)="queryComplaints()" class="form-control filters-select fa-caret-down">
                <option>
                  Todos
                </option>
                <option *ngFor="let place of placeComplaint">
                  {{ place }}
                </option>
              </select>
            </div>
            <div class="form-group col-md-2 d-btn-filter">
              <button id="btnSubmitFilter" (click)="queryComplaints()" type="submit"
                class="btn btn-primary">Filtrar</button>
            </div>
          </div>
        </form>
      </div>
      -->
      <div *ngIf="loadFilter" class="spinner">
        <mat-spinner></mat-spinner>
      </div>

      <div
        class="container-filter-animation filter-advanced"
        style="
          max-width: 1300px;
          margin: 0 auto;
          padding-left: 3px;
          margin-top: 20px;
        "
      >
        <div
          style="
            font-size: 14px;
            font-style: normal;
            font-weight: 500;
            line-height: 20px;
            color: #5d53a7;
            display: flex;
            align-items: center;
            cursor: pointer;
          "
        >
          <p style="margin: 0">
            {{ "OcurrencesListTableAdvancedFilters" | translate }}
          </p>
          <mat-icon
            (click)="openInformationEvent($event)"
            class="filter-advanced"
            style="height: auto; transition: transform 0.5s ease"
            matDatepickerToggleIcon
            >keyboard_arrow_down</mat-icon
          >
        </div>

        <div class="filter-advanced unshow">
          <form
            [formGroup]="searchFilter"
            style="margin-top: 10px; display: flex; flex-direction: column"
          >
            <div
              style="
                display: flex;
                width: 100%;
                justify-content: space-between;
                margin-bottom: 15px;
              "
            >
              <div style="display: flex; flex-direction: column">
                <label
                  style="
                    font-size: 12px;
                    font-style: normal;
                    font-weight: 500;
                    line-height: 16px;
                    color: #938f94;
                    margin: 2px;
                  "
                >
                  {{ "OcurrencesListFiltersSublocality" | translate }}
                </label>
                <mat-form-field
                  id="select"
                  style="
                    width: 260px;
                    background-color: #e5deff;
                    border-radius: 8px;
                  "
                >
                  <mat-icon style="color: #5d53a7" matSuffix
                    >keyboard_arrow_down</mat-icon
                  >
                  <mat-select
                    formControlName="sublocalityComplaint"
                    (change)="queryComplaints()"
                    style="
                      width: 240px;
                      justify-content: center;
                      font-family: Roboto;
                      font-size: 18px !important;
                      font-style: italic;
                      font-weight: 400 !important;
                      line-height: 20px !important;
                      display: flex;
                      align-items: center;
                      flex-direction: column;
                      color: #453a8d !important;
                    "
                  >
                    <mat-option [value]="'Todos'">
                      {{ "OcurrencesListFiltersSublocalityAll" | translate }}
                    </mat-option>
                    <mat-option
                      *ngFor="let sublocality of sublocalities"
                      [value]="sublocality"
                    >
                      {{ sublocality }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <div style="display: flex; flex-direction: column">
                <label
                  style="
                    font-size: 12px;
                    font-style: normal;
                    font-weight: 500;
                    line-height: 16px;
                    color: #938f94;
                    margin: 2px;
                  "
                >
                  {{ "OcurrencesListFiltersPlace" | translate }}
                </label>
                <mat-form-field
                  id="select"
                  style="
                    width: 260px;
                    background-color: #e5deff;
                    border-radius: 8px;
                  "
                >
                  <mat-icon style="color: #5d53a7" matSuffix
                    >keyboard_arrow_down</mat-icon
                  >
                  <mat-select
                    formControlName="placeComplaint"
                    (change)="queryComplaints()"
                    style="
                      width: 240px;
                      justify-content: center;
                      font-family: Roboto;
                      font-size: 18px !important;
                      font-style: italic;
                      font-weight: 400 !important;
                      line-height: 20px !important;
                      display: flex;
                      align-items: center;
                      flex-direction: column;
                      color: #453a8d !important;
                    "
                  >
                    <mat-option [value]="'Todos'">
                      {{ "OcurrencesListFiltersPlaceAll" | translate }}
                    </mat-option>
                    <mat-option
                      *ngFor="let place of placeComplaint"
                      [value]="place"
                    >
                      {{ place }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <div style="display: flex; flex-direction: column">
                <label
                  style="
                    font-size: 12px;
                    font-style: normal;
                    font-weight: 500;
                    line-height: 16px;
                    color: #938f94;
                    margin: 2px;
                  "
                >
                  {{ "OcurrencesListFiltersBusLine" | translate }}
                </label>
                <mat-form-field
                  id="select"
                  style="
                    width: 260px;
                    background-color: #e5deff;
                    border-radius: 8px;
                  "
                >
                  <mat-icon style="color: #5d53a7" matSuffix
                    >keyboard_arrow_down</mat-icon
                  >
                  <mat-select
                    formControlName="busLine"
                    (change)="queryComplaints()"
                    style="
                      width: 240px;
                      justify-content: center;
                      font-family: Roboto;
                      font-size: 18px !important;
                      font-style: italic;
                      font-weight: 400 !important;
                      line-height: 20px !important;
                      display: flex;
                      align-items: center;
                      flex-direction: column;
                      color: #453a8d !important;
                    "
                  >
                    <mat-option [value]="'Todos'">
                      {{ "OcurrencesListFiltersBusLineAll" | translate }}
                    </mat-option>
                    <mat-option *ngFor="let line of linesName" [value]="line">
                      {{ line }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <div style="display: flex; flex-direction: column">
                <label
                  style="
                    font-size: 12px;
                    font-style: normal;
                    font-weight: 500;
                    line-height: 16px;
                    color: #938f94;
                    margin: 2px;
                  "
                >
                  {{ "OcurrencesListFiltersType" | translate }}
                </label>
                <mat-form-field
                  id="select"
                  style="
                    width: 260px;
                    background-color: #e5deff;
                    border-radius: 8px;
                  "
                >
                  <mat-icon style="color: #5d53a7" matSuffix
                    >keyboard_arrow_down</mat-icon
                  >
                  <mat-select
                    formControlName="typeComplaint"
                    (change)="queryComplaints()"
                    style="
                      width: 240px;
                      justify-content: center;
                      font-family: Roboto;
                      font-size: 18px !important;
                      font-style: italic;
                      font-weight: 400 !important;
                      line-height: 20px !important;
                      display: flex;
                      align-items: center;
                      flex-direction: column;
                      color: #453a8d !important;
                    "
                  >
                    <mat-option [value]="'Todos'">
                      {{ "OcurrencesListFiltersTypeAll" | translate }}
                    </mat-option>
                    <mat-option
                      *ngFor="let type of typesComplaint"
                      [value]="type"
                    >
                      {{ type }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>

            <div
              style="
                display: flex;
                width: 100%;
                justify-content: space-between;
                margin-bottom: 15px;
              "
            >
              <div style="display: flex; flex-direction: column">
                <label
                  style="
                    font-size: 12px;
                    font-style: normal;
                    font-weight: 500;
                    line-height: 16px;
                    color: #938f94;
                    margin: 2px;
                  "
                >
                  {{ "OcurrencesListFiltersGender" | translate }}
                </label>
                <mat-form-field
                  id="select"
                  style="
                    width: 260px;
                    background-color: #e5deff;
                    border-radius: 8px;
                  "
                >
                  <mat-icon style="color: #5d53a7" matSuffix
                    >keyboard_arrow_down</mat-icon
                  >
                  <mat-select
                    formControlName="genderComplaint"
                    (change)="queryComplaints()"
                    class="mat-gender-select"
                  >
                    <mat-option [value]="'Todos'">
                      {{ "OcurrencesListFiltersGenderAll" | translate }}
                    </mat-option>
                    <mat-option [value]="'WOMAN_TRANS'">
                      {{ "OcurrencesListFiltersGenderTransWoman" | translate }}
                    </mat-option>
                    <mat-option [value]="'WOMAN_CIS'">
                      {{ "OcurrencesListFiltersGenderCisWoman" | translate }}
                    </mat-option>
                    <mat-option [value]="'MAN_TRANS'">
                      {{ "OcurrencesListFiltersGenderTransMan" | translate }}
                    </mat-option>
                    <mat-option [value]="'MAN_CIS'">
                      {{ "OcurrencesListFiltersGenderCisMan" | translate }}
                    </mat-option>
                    <mat-option [value]="'NON_BINARY'">
                      {{ "OcurrencesListFiltersGenderNonBinary" | translate }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>

            <div class="container-button">
              <button
                class="btn btn-outline-clear custom-button"
                (click)="limparFiltros()"
              >
                {{ "OcurrencesListFiltersCleanFilters" | translate }}
              </button>
              <button
                (click)="queryComplaints()"
                class="btn btn-outline-secundary custom-button"
              >
                {{ "OcurrencesListFiltersSubmit" | translate }}
              </button>
            </div>
          </form>
        </div>
      </div>
      <div
        class="card card-table"
        style="width: 100%; height: auto; background: #fffbff"
      >
        <div
          *ngIf="!loadFilter"
          style="max-width: 1300px; margin: 0 auto"
          class="table__wrapper"
        >
          <table mat-table [dataSource]="dataSourceDenounces">
            <ng-container matColumnDef=" " class="column-list">
              <th
                mat-header-cell
                *matHeaderCellDef
                style="text-align: left !important"
              ></th>
              <td
                (click)="seeDetails(element._id)"
                mat-cell
                *matCellDef="let element"
                style="cursor: pointer; font-size: 16px"
              >
                <div>
                  <img src="assets/icons/eyeWithBg.svg" alt="" />
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="sublocality" class="column-list">
              <th
                mat-header-cell
                *matHeaderCellDef
                style="
                  text-align: left !important;
                  width: 35%;
                  position: relative;
                "
                [class.selected-icon]="orderBy[0] == 'sublocality'"
                (click)="sortData('sublocality')"
              >
                {{ "OcurrencesListTableSublocality" | translate }}

                <mat-icon
                  *ngIf="!sublocalityAsc"
                  style="margin-bottom: -0.5rem; position: absolute"
                  >keyboard_arrow_down</mat-icon
                >
                <mat-icon
                  *ngIf="sublocalityAsc"
                  style="margin-bottom: -0.5rem; position: absolute"
                  >keyboard_arrow_up</mat-icon
                >
              </th>
              <td
                mat-cell
                *matCellDef="let element"
                style="cursor: pointer; font-size: 16px; width: 35%"
                (click)="seeDetails(element._id)"
              >
                <div
                  style="
                    display: flex;
                    width: 100%;
                    height: 100%;
                    gap: 10px;
                    align-items: center;
                    justify-content: space-between;
                  "
                >
                  <p style="margin: 0; width: 80%; text-align: left">
                    {{ element.sublocality }}
                  </p>
                </div>
              </td>
            </ng-container>
            <!-- Date Created Column -->
            <ng-container matColumnDef="date_created" class="column-list">
              <th
                mat-header-cell
                *matHeaderCellDef
                style="text-align: left !important; width: 10%"
                [class.selected-icon]="orderBy[0] == 'created_at'"
                (click)="sortData('created_at')"
              >
                {{ "OcurrencesListTableReportedAt" | translate }}

                <mat-icon
                  *ngIf="!dateCreatedAsc"
                  style="margin-bottom: -0.5rem; position: absolute"
                  >keyboard_arrow_down</mat-icon
                >
                <mat-icon
                  *ngIf="dateCreatedAsc"
                  style="margin-bottom: -0.5rem; position: absolute"
                  >keyboard_arrow_up</mat-icon
                >
              </th>
              <td
                mat-cell
                *matCellDef="let element"
                style="text-align: left !important; width: 10%"
                (click)="seeDetails(element._id)"
              >
                {{ element.created_at | date : "dd/MM/yyyy" : "PST" }}
              </td>
            </ng-container>

            <!-- Date Column -->
            <ng-container matColumnDef="date" class="column-list">
              <th
                mat-header-cell
                *matHeaderCellDef
                style="text-align: left !important; width: 10%"
                [class.selected-icon]="orderBy[0] == 'datetime'"
                (click)="sortData('datetime')"
              >
                {{ "OcurrencesListTableOcurredAt" | translate }}

                <mat-icon
                  *ngIf="!dateAsc"
                  style="margin-bottom: -0.5rem; position: absolute"
                  >keyboard_arrow_down</mat-icon
                >
                <mat-icon
                  *ngIf="dateAsc"
                  style="margin-bottom: -0.5rem; position: absolute"
                  >keyboard_arrow_up</mat-icon
                >
              </th>
              <td
                mat-cell
                *matCellDef="let element"
                style="text-align: left !important; width: 10%"
                (click)="seeDetails(element._id)"
              >
                {{ element.datetime | date : "dd/MM/yyyy" : "PST" }}
              </td>
            </ng-container>

            <!-- Place Column -->
            <ng-container matColumnDef="place" class="column-list">
              <th
                mat-header-cell
                *matHeaderCellDef
                style="text-align: left !important; width: 13%"
                [class.selected-icon]="orderBy[0] == 'place'"
                (click)="sortData('place')"
              >
                {{ "OcurrencesListTablePlace" | translate }}

                <mat-icon
                  *ngIf="!placeAsc"
                  style="margin-bottom: -0.5rem; position: absolute"
                  >keyboard_arrow_down</mat-icon
                >
                <mat-icon
                  *ngIf="placeAsc"
                  style="margin-bottom: -0.5rem; position: absolute"
                  >keyboard_arrow_up</mat-icon
                >
              </th>
              <td
                mat-cell
                *matCellDef="let element"
                style="text-align: left !important; width: 10%"
                (click)="seeDetails(element._id)"
              >
                {{ translatePlace(element.place) }}
              </td>
            </ng-container>

            <!-- Type Column -->
            <ng-container matColumnDef="type" class="column-list">
              <th
                mat-header-cell
                *matHeaderCellDef
                [class.selected-icon]="orderBy[0] == 'type'"
                style="text-align: left !important; width: 25%"
                (click)="sortData('type')"
              >
                {{ "OcurrencesListTableType" | translate }}

                <mat-icon
                  *ngIf="!typeAsc"
                  style="margin-bottom: 0.5rem; position: absolute"
                  >keyboard_arrow_down</mat-icon
                >
                <mat-icon
                  *ngIf="typeAsc"
                  style="margin-bottom: 0.5rem; position: absolute"
                  >keyboard_arrow_up</mat-icon
                >
              </th>
              <td
                mat-cell
                *matCellDef="let element"
                (click)="seeDetails(element._id)"
                style="text-align: left !important; width: 25%"
              >
                <div
                  *ngFor="let tipo of element.type.slice(0, 2)"
                  style="
                    border-radius: 100px;
                    color: #180064;
                    background: var(
                      --material-theme-ref-primary-primary-80,
                      #e5deff
                    );
                    display: inline-flex;
                    padding: 4px 8px;
                    justify-content: center;
                    align-items: center;
                    margin-right: 5px;
                    gap: 8px;
                  "
                >
                  {{ translateType(tipo) }}
                </div>

                <div
                  *ngIf="element.type.length >= 3"
                  style="
                    border-radius: 100px;
                    color: #180064;
                    background: var(
                      --material-theme-ref-primary-primary-80,
                      #e5deff
                    );
                    display: inline-flex;
                    padding: 4px 8px;
                    justify-content: center;
                    align-items: center;
                    margin-right: 5px;
                    gap: 8px;
                  "
                >
                  ...
                </div>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr
              mat-row
              class="ocurrence-row"
              *matRowDef="let row; let i = index; columns: displayedColumns"
              [class.darkened-row]="i % 2 !== 0"
            ></tr>
          </table>
        </div>
        <mat-paginator
          [pageSizeOptions]="[5, 10, 15]"
          [pageIndex]="pageIndex"
          (page)="changePage($event)"
          showFirstLastButtons
        >
        </mat-paginator>
      </div>

      <div class="usuario-reincidencia">
        <div class="reincidencia-title">
          <h3>
            {{ "OcurrencesListRecurrentUsers" | translate }}
          </h3>

          <button *ngIf="user_id_complaint" (click)="limparId()">
            <img src="assets/icons/close.svg" alt="" />
          </button>
        </div>

        <ngb-carousel
          class="carousel-fade"
          #carousel
          [interval]="20000"
          [showNavigationArrows]="false"
        >
          <ng-template
            *ngFor="let listaIncidencia of usuariosReicidencias"
            ngbSlide
          >
            <div class="reincidencia-item">
              <div
                *ngFor="let usuario of listaIncidencia"
                (click)="capturarID(usuario._id)"
                class="reincidencia-card"
              >
                <div style="display: flex; gap: 15px; align-items: center">
                  <img src="assets/icons/eyeWithBg.svg" alt="" />
                  <p style="margin: 0">{{ usuario._id }}</p>
                </div>
                <div class="reincidencia-count">
                  {{ usuario.count }}
                  {{ "OcurrencesListRecurrentUsersRegisters" | translate }}
                </div>
              </div>
            </div>
          </ng-template>
        </ngb-carousel>
      </div>
    </div>
  </div>
</div>
